import { INIT_PAGINATION } from '@vindr/services/constants/common.constant';
import { DefinedColumns, PaginationProps } from '@vindr/services/interfaces';
import { isEmptyObject } from '@vindr/utils/helpers/common.helper';

interface IndexColumnProps<T> extends DefinedColumns<T> {
  pagination?: PaginationProps;
}

const IndexColumn = <T,>(props?: Partial<IndexColumnProps<T>>): IndexColumnProps<T> => {
  const {
    pagination,
    title = '#',
    width = 40,
    key = 'index' as keyof T | any,
    dataIndex = 'index' as keyof T | any,
    ...rest
  } = props || {};

  return {
    title,
    width,
    align: 'center',
    key,
    dataIndex,
    render: (text, record, index) => {
      const { size, page } =
        isEmptyObject(pagination) || !pagination ? INIT_PAGINATION : pagination;

      return size * (page - 1) + index + 1;
    },
    ...rest,
  };
};

export default IndexColumn;
